import React from 'react';
import { LayoutGrid, Table2 } from 'lucide-react';

/** Console-exact table / cards segmented toggle (38px height). */
export default function QawaemTableCardsViewToggle({ value, onChange, className = '' }) {
  return (
    <div
      className={`qawaem-view-toggle flex items-center h-[38px] border border-[#6e9b6e]/15 rounded-lg overflow-hidden shrink-0 ${className}`}
      role="group"
      aria-label="طريقة العرض"
    >
      <button
        type="button"
        onClick={() => onChange('cards')}
        className={`h-full px-2.5 flex items-center justify-center transition-colors ${
          value === 'cards' ? 'bg-[#6e9b6e]/15 text-[#5a855a]' : 'text-console-muted hover:bg-[#6e9b6e]/5'
        }`}
        title="بطاقات"
        aria-pressed={value === 'cards'}
      >
        <LayoutGrid size={17} />
      </button>
      <button
        type="button"
        onClick={() => onChange('table')}
        className={`h-full px-2.5 flex items-center justify-center border-s border-[#6e9b6e]/12 transition-colors ${
          value === 'table' ? 'bg-[#6e9b6e]/15 text-[#5a855a]' : 'text-console-muted hover:bg-[#6e9b6e]/5'
        }`}
        title="جدول"
        aria-pressed={value === 'table'}
      >
        <Table2 size={17} />
      </button>
    </div>
  );
}
